import React from 'react';
import { motion } from 'framer-motion';
import ServiceCard from './ServiceCard';
import { ArrowRight } from 'lucide-react';
import { 
  Lightbulb, 
  Power, 
  Wifi, 
  AlertTriangle, 
  ShoppingBag, 
  FileCheck 
} from 'lucide-react';

const ServicesSection: React.FC = () => {
  const services = [
    {
      icon: Lightbulb,
      title: 'Lichtinstallaties',
      description:
        'Professionele installatie van verlichting voor woningen en bedrijven, van standaard verlichting tot complete lichtplannen.',
    },
    {
      icon: Power,
      title: 'Krachtinstallaties',
      description:
        'Aanleg en onderhoud van krachtinstallaties voor machines en apparatuur die meer vermogen vereisen.',
    },
    {
      icon: Wifi,
      title: 'Zwakstroominstallaties',
      description:
        'Installatie van netwerken, telefonie, intercom, alarm- en beveiligingssystemen voor optimale connectiviteit.',
    },
    {
      icon: AlertTriangle,
      title: 'Storingen oplossen',
      description:
        'Snelle en efficiënte diagnose en reparatie van elektrische storingen, 24 uur per dag bereikbaar.',
    },
    {
      icon: ShoppingBag,
      title: 'Verkoop producten',
      description:
        'Verkoop van hoogwaardige verlichting en installatiemateriaal met deskundig advies voor uw specifieke situatie.',
    },
    {
      icon: FileCheck,
      title: 'Keuringen',
      description:
        'Officiële keuringen volgens NEN 1010 en NEN 3140 normen om de veiligheid van uw elektrische installaties te waarborgen.',
    },
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-14">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="section-eyebrow"
          >
            Wat wij doen
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="text-3xl md:text-4xl font-bold mb-4 text-navy-800"
          >
            Onze Diensten
          </motion.h2>
          <div className="flex justify-center mb-4">
            <div className="divider-accent"></div>
          </div>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="text-navy-700 max-w-2xl mx-auto"
          >
            HTS Electrotechniek biedt een breed scala aan elektrotechnische diensten
            voor zowel particuliere als zakelijke klanten.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.5,
                delay: 0.1 * index,
              }}
            >
              <ServiceCard
                icon={service.icon}
                title={service.title}
                description={service.description}
              />
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.6 }}
          className="text-center mt-12"
        >
          <a
            href="/services"
            className="btn-secondary"
          >
            Alle diensten bekijken
            <ArrowRight size={18} className="ml-2" />
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default ServicesSection;
